{
  "_format": "hh-sol-artifact-1",
  "contractName": "Loan",
  "sourceName": "contracts/Loan.sol",
  "abi": [
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "pool",
          "type": "address"
        }
      ],
      "name": "FundsReclaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "enum ILoanLifeCycleState",
          "name": "state",
          "type": "uint8"
        }
      ],
      "name": "LifeCycleStateTransition",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "lender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "LoanDeposit",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "asset",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "LoanFunded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "enum ILoanTransitionState",
          "name": "transitionState",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "timestamp",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "windowStart",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "windowEnd",
          "type": "uint256"
        }
      ],
      "name": "LoanScheduleViolation",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "_assetsRolloverToNextLoan",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "_assetsToReturnToPool",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "accrualStartDayTimestamp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "accrualStartTimestamp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "approve",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "assetsFromPool",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "assetsRolloverToNextLoan",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "assetsToReturnToPool",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "borrower",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "canRequestRedemption",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "completeRolloverNetPayment",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "feeVaultAmount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "assetsReturnedToPool",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "interestAccrued",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "createdAt",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "crossChainTransferBurnSource",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "assetsAtMaturity",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "assetsAtMaturity",
          "type": "uint256"
        }
      ],
      "name": "crossChainTransferMintDestination",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "lender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "depoistToLoan",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "depositClosingTimestamp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "dropDeadTimestamp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "durationDays",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "earlyRedeemRequestClosingTimestamp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "exchangeRateAtDeposit",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "exchangeRateAtMaturity",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "factory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "finalizedApr",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "assetsFromPool_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "assetsFromPriorLoan",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "totalSupply",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "priorLoan",
          "type": "address"
        }
      ],
      "name": "fundRollover",
      "outputs": [
        {
          "internalType": "enum ILoanLifeCycleState",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "fundingVault",
      "outputs": [
        {
          "internalType": "contract IVault",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getRolloverAccounting",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "totalSupply",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "assetsFromPool",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "assetsFromPriorLoan",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "assetToReturnToPool",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "exchangeRateAtDeposit",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "exchangeRateAtMaturity",
              "type": "uint256"
            }
          ],
          "internalType": "struct ILoanRolloverAccounting",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "inDepositWindow",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "inInitiateRolloverWindow",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "indicativeApr",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "indicativeInterest",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "serviceConfiguration_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "factory_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "borrower_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "pool_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "liquidityAsset_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "vaultFactory",
          "type": "address"
        },
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "principal",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "indicativeApr",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "finalizedApr",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "durationDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "dropDeadTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "originationBps",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "accrualStartDayTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferInWindowDurationDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutWindowDurationDays",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "priorLoan",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "startingPrincipal",
              "type": "uint256"
            }
          ],
          "internalType": "struct ILoanSettings",
          "name": "settings_",
          "type": "tuple"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "interest",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "liquidityAsset",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "maturingTimestamp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "originationFee",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pool",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolAccessControl",
      "outputs": [
        {
          "internalType": "contract IPoolAccessControl",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "principal",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "redemptionAvailableTimestamp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "redemptionRequestClosingTimestamp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "principal_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "assetReduction",
          "type": "uint256"
        }
      ],
      "name": "repayEarlyWithdraw",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "accrualStartDayTimestamp_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "transferInWindowDurationDays_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "transferOutWindowDurationDays_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "durationDays_",
          "type": "uint256"
        }
      ],
      "name": "reschedule",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rolloverAccounting",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "totalSupply",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "assetsFromPool",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "assetsFromPriorLoan",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "assetToReturnToPool",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "exchangeRateAtDeposit",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "exchangeRateAtMaturity",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "assetsRolloverToNextLoan_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "assetToReturnToPool_",
          "type": "uint256"
        }
      ],
      "name": "rolloverAllocation",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_apr",
          "type": "uint256"
        }
      ],
      "name": "rolloverAndFinalizeApr",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rolloverMaturedLoan",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "timestamp",
          "type": "uint256"
        }
      ],
      "name": "roundToDays",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "serviceConfiguration",
      "outputs": [
        {
          "internalType": "contract IServiceConfigurationV5",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "settings",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "principal",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "indicativeApr",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "finalizedApr",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "durationDays",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "dropDeadTimestamp",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "originationBps",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "accrualStartDayTimestamp",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "transferInWindowDurationDays",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "transferOutWindowDurationDays",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "priorLoan",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "startingPrincipal",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "startingPrincipal",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "state",
      "outputs": [
        {
          "internalType": "enum ILoanLifeCycleState",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "transferInWindowDurationDays",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "transferOutWindowDurationDays",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "transitionState",
      "outputs": [
        {
          "internalType": "enum ILoanTransitionState",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "version",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    }
  ],
  "bytecode": "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__$2a2a3402855f46317c6bdb0fbb7ee08164$__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__$2a2a3402855f46317c6bdb0fbb7ee08164$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",
  "deployedBytecode": "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__$2a2a3402855f46317c6bdb0fbb7ee08164$__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__$2a2a3402855f46317c6bdb0fbb7ee08164$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",
  "linkReferences": {
    "contracts/libraries/LoanLib.sol": {
      "LoanLib": [
        {
          "length": 20,
          "start": 3448
        },
        {
          "length": 20,
          "start": 6982
        }
      ]
    }
  },
  "deployedLinkReferences": {
    "contracts/libraries/LoanLib.sol": {
      "LoanLib": [
        {
          "length": 20,
          "start": 3191
        },
        {
          "length": 20,
          "start": 6725
        }
      ]
    }
  }
}
